import {InMemoryCache, PossibleTypesMap} from '@apollo/client';
import {cacheSizes} from '@apollo/client/utilities';
import {entry, objectFromEntries} from '@benchling/js-utils';

import dataIdFromBenchlingObject from './dataIdFromBenchlingObject';
import GraphQLIntrospectionResult from './schema/GraphQLIntrospectionResult';
import {typeIsAbstract} from './schema/util/SchemaOps';
import typePolicies from './typePolicies';

export default function createInMemoryCache(): InMemoryCache {
  // Adjust cache sizes because v3.9.x decreased average cache sizes.  These larger sizes support our data.
  cacheSizes['inMemoryCache.executeSelectionSet'] = 75000;
  cacheSizes['inMemoryCache.executeSubSelectedArray'] = 75000;

  const abstractTypes = GraphQLIntrospectionResult.__schema.types.filter((t) => typeIsAbstract(t));

  const possibleTypeEntries = abstractTypes
    .filter((type) => type.possibleTypes)
    .map((type) =>
      entry<Array<string>>(
        type.name,
        type.possibleTypes.map((subtype) => subtype.name)
      )
    );

  const possibleTypes: PossibleTypesMap = objectFromEntries(possibleTypeEntries);

  return new InMemoryCache({
    possibleTypes,
    typePolicies,
    dataIdFromObject: dataIdFromBenchlingObject,
  });
}
